import React from 'react'

function InvoiceFooter() {
  return (
    <></>
  )
}

export default InvoiceFooter